const IframeGame = ({ userResponse }) => {

    return (
        <>
            {userResponse?.result?.user_response?.map((item, index) => {
                switch (item.response_type) {
                    case "iframe_experience":
                        return (
                            <>
                                <iframe src={item.response} title="Game" className="iframe-game" frameBorder="0"></iframe>
                            </>
                        );
                    default:
                        return null;
                }
            })}
        </>
    )
}
export default IframeGame;